/* Whitehouse Lighting & Electrical — V20.1 product-page -> product-card bridge
   Sources: Shopify product and technical metafields passed by whle-product-exporter-integrated.liquid.
   This script only owns [data-whle-card-download] and [data-whle-card-preview].
   It does NOT submit a cart, edit products, or change quote/wishlist logic. */
(() => {
  'use strict';
  const bound = new WeakSet();
  const safeId = s => String(s ?? '');

  function productRoot(el) { return el.closest('[data-whl-main-product]'); }
  function getRecord(root) {
    const el = root.querySelector('[data-whle-integrated-source] [data-whle-export-json]');
    if (!el) throw new Error('The integrated product-card data is missing. Install the matching Liquid snippet.');
    return JSON.parse(el.textContent);
  }
  function activeVariant(root, record) {
    const native = root.querySelector('.whl-ordered-buy-actions form [name="id"]') ||
                   root.querySelector('.product__info-container form [name="id"]');
    const fromInput = native && safeId(native.value);
    const ids = new Set((record.variants || []).map(v => safeId(v.id)));
    if (fromInput && ids.has(fromInput)) return fromInput;
    const fromUrl = new URL(window.location.href).searchParams.get('variant');
    if (fromUrl && ids.has(fromUrl)) return fromUrl;
    return safeId(record.variantId);
  }
  function selectedImage(record, variant) {
    const id = safeId(variant?.featuredImageId);
    const at = (record.images || []).findIndex(x => id && safeId(x.id) === id);
    return at >= 0 ? at : 0;
  }
  function filename(record, variant) {
    const n = window.WHLECardExporter?.filenameFor;
    return n ? n(record,variant) : 'whitehouse-product-card-1080x1350.png';
  }
  function triggerDownload(canvas, name) {
    return new Promise((resolve,reject) => {
      try {
        canvas.toBlob(blob => {
          if (!blob) return reject(new Error('The browser could not create the PNG. Check cross-origin product images.'));
          const u = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = u; a.download = name;
          document.body.appendChild(a);a.click();a.remove();
          setTimeout(() => URL.revokeObjectURL(u),2000);
          resolve();
        }, 'image/png');
      } catch (e) { reject(e); }
    });
  }
  async function download(root, trigger) {
    const label = trigger.querySelector('span');
    const before = label?.textContent;
    if (trigger.disabled) return;
    trigger.disabled = true; trigger.setAttribute('aria-busy','true');
    if (label) label.textContent = 'Preparing PNG…';
    try {
      const api = window.WHLECardExporter;
      if (!api || typeof api.renderCard !== 'function') throw new Error('Exporter JavaScript is not available.');
      const record = getRecord(root);
      const variantId = activeVariant(root, record);
      const variant = (record.variants || []).find(v=>safeId(v.id) === variantId) || (record.variants || [])[0];
      const result = await api.renderCard(record,{variantId, heroIndex:selectedImage(record,variant)});
      if (!result.hasHero) throw new Error('A product image is required to download the advertising card.');
      await triggerDownload(result.canvas,filename(record,variant));
      trigger.setAttribute('data-whle-export-last-status','started');
    } catch (error) {
      console.error('[Whitehouse card export]',error);
      window.alert('Product card download failed: '+error.message);
    } finally {
      trigger.disabled = false;trigger.removeAttribute('aria-busy');
      if (label) label.textContent = before;
    }
  }
  function preview(root) {
    const source = root.querySelector('[data-whle-integrated-source]');
    const trigger = source?.querySelector('[data-whle-export-open]');
    if (!trigger) throw new Error('Card editor trigger not found in integrated exporter.');
    const data = getRecord(root);
    const variantId = activeVariant(root,data);
    data.variantId = variantId;
    const script = source.querySelector('[data-whle-export-json]');
    if (script) script.textContent = JSON.stringify(data);
    trigger.dispatchEvent(new MouseEvent('click', {bubbles:true,shiftKey:true}));
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-whle-card-download],[data-whle-card-preview]').forEach(trigger=>{
      if (bound.has(trigger))return;
      bound.add(trigger);
      trigger.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        const root = productRoot(trigger);
        if(!root)return;
        if (trigger.matches('[data-whle-card-preview]') || event.shiftKey) {
          try{preview(root);}catch(e){console.error(e);window.alert(e.message);}
        } else download(root,trigger);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  window.WHLEProductCardBridge = {version:'20.1',activeVariant,selectedImage};
})();
